<div class="maplibre-gl-container" [class.weather-active]="activeWeatherLayer">
  <div #mapContainer class="map-element" [style.height]="height">
    <div class="map-loading" *ngIf="!isMapInitialized">
      <div class="loading-spinner"></div>
      <p>Loading map...</p>
    </div>
  </div>
  
  <!-- Weather Layer Switcher -->
  <div class="weather-layer-switcher" *ngIf="showWeatherControls && isMapInitialized">
    <button 
      class="weather-btn"
      [class.active]="activeWeatherLayer === 'precipitation-svg'"
      (click)="toggleWeatherLayer('precipitation-svg')"
      [disabled]="loadingWeatherLayer">
      <i class="pi pi-cloud"></i>
      <span>Осадки (SVG)</span>
    </button>
    <button 
      class="weather-btn"
      [class.active]="activeWeatherLayer === 'precipitation-canvas'"
      (click)="toggleWeatherLayer('precipitation-canvas')"
      [disabled]="loadingWeatherLayer">
      <i class="pi pi-cloud"></i>
      <span>Осадки (Canvas)</span>
    </button>
  </div>
</div>